import TableRow, { TableRowProps } from '@mui/material/TableRow'
import { styled } from '@mui/material/styles'
import type { CSSProperties } from 'react'

export type StyledTableRowVariant = 'default' | 'compact'

interface StyledTableRowProps extends TableRowProps {
    variant?: StyledTableRowVariant
    verticalAlign?: CSSProperties['verticalAlign']
    clickable?: boolean
    disabled?: boolean
    hoverActions?: boolean
    borderedCells?: boolean
}

export const StyledTableRow = styled(TableRow, {
    shouldForwardProp: (prop) =>
        prop !== 'variant' &&
        prop !== 'verticalAlign' &&
        prop !== 'clickable' &&
        prop !== 'disabled' &&
        prop !== 'hoverActions' &&
        prop !== 'borderedCells',
})<StyledTableRowProps>(
    ({
        theme,
        variant = 'default',
        verticalAlign = 'middle',
        clickable,
        disabled,
        hoverActions,
        borderedCells,
    }) => ({
        '& .MuiTableCell-root': {
            verticalAlign,
        },
        '& ul': {
            marginBottom: 0,
            '& li': {
                padding: 0,
                '&:not(:last-of-type)': {
                    paddingBottom: theme.spacing(0.5),
                },
            },
        },
        '& .displayItem': {
            marginTop: 0,
        },
        '& .MuiTableCell-head': {
            textAlign: 'left',
            fontWeight: 'bold',
        },
        ...(variant === 'compact' && {
            '& .MuiTableCell-root': {
                padding: theme.spacing(1),
                verticalAlign,
            },
        }),
        ...(clickable && {
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: theme.palette.action.hover,
            },
        }),
        ...(disabled && {
            cursor: 'default',
            opacity: theme.palette.action.disabledOpacity,
            pointerEvents: 'none',
        }),
        ...(borderedCells && {
            '& td, & th': {
                borderBottom: '1px solid',
                borderColor: 'divider',
            },
        }),
        ...(hoverActions && {
            '& [data-cell-inline-edit]': {
                position: 'relative',
                verticalAlign: 'middle',
                whiteSpace: 'nowrap',
                textAlign: 'center',
                minWidth: '40px',
                width: '40px',
            },

            '& [data-cell-inline-action]': {
                display: 'none',
                width: '28px',
                height: '28px',
                minWidth: '28px',
                padding: 0,
            },
            '&:hover [data-cell-inline-action]': {
                display: 'inline-block',
                position: 'absolute',
                right: 0,
                top: 0,
                marginTop: theme.spacing(0.5),
                marginRight: theme.spacing(1),
                zIndex: 1,
            },
        }),
    })
)
